import React, { useState } from 'react'
import { IconBulb } from '@tabler/icons-react'

import { Accordion } from '@/components/accordions/Accordion'
import { Button } from '@/components/buttons/Button'

const InsightAccordion = ({ isAdmin, icon, title, actions, content }) => {
  const [expanded, setExpanded] = useState(false)

  if (!isAdmin) {
    return (
      <div className="flex-align-center gap">
        {icon}
        {title}
        {actions}
      </div>
    )
  }

  return (
    <Accordion
      id="insight"
      icon={icon}
      title={title}
      actions={actions}
      expanded={expanded}
      handleToggle={() => setExpanded(!expanded)}
    >
      <span>{content}</span>
    </Accordion>
  )
}

export const EntryInsight = ({
  insightDetails = [],
  fieldName,
  insightAction,
  handleDeleteListItem,
  isAdmin,
}) => {
  if (!fieldName) {
    return null
  }

  return (
    <div className="entry-insight">
      {insightDetails
        .filter((insight) => insight.item === fieldName.name)
        .map(({ hit_fraction, win_fraction, drop_performance, drop_count }) =>
          drop_performance ? (
            <InsightAccordion
              key="drop_performance"
              isAdmin={isAdmin}
              icon={<IconBulb className="icon-svg status-informative" />}
              title={
                <span>
                  This decklist item has poor performance. Consider
                  <Button
                    text
                    onClick={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      insightAction('accept', 'drop_performance')
                      if (handleDeleteListItem) {
                        handleDeleteListItem()
                      }
                    }}
                  >
                    removing it.
                  </Button>
                </span>
              }
              actions={
                <Button
                  text
                  onClick={(event) => {
                    event.stopPropagation()
                    insightAction('dismiss', 'drop_performance')
                  }}
                >
                  Dismiss
                </Button>
              }
              content={`This item's win percentage is ${(win_fraction * 100).toFixed(2)}%.`}
            />
          ) : drop_count ? (
            <InsightAccordion
              key="drop_count"
              isAdmin={isAdmin}
              icon={<IconBulb className="icon-svg status-informative" />}
              title={
                <span>
                  This decklist item is infrequently used. Consider
                  <Button
                    text
                    onClick={(event) => {
                      event.preventDefault()
                      event.stopPropagation()
                      insightAction('accept', 'drop_count')
                      if (handleDeleteListItem) {
                        handleDeleteListItem()
                      }
                    }}
                  >
                    removing it.
                  </Button>
                </span>
              }
              actions={
                <Button
                  text
                  onClick={(event) => {
                    event.stopPropagation()
                    insightAction('dismiss', 'drop_count')
                  }}
                >
                  Dismiss
                </Button>
              }
              content={`This item's use percentage is ${(hit_fraction * 100).toFixed(2)}%.`}
            />
          ) : null
        )}
    </div>
  )
}
